export default __webpack_public_path__ + "static/media/bitcoin.c7458bce.png";